export { default } from './Loading.molecule';
